// eslint-disable-next-line @typescript-eslint/no-require-imports
export const faviconPath: string = require('@ms/yammer-assets/dist/web/ve/favicon.ico');
// eslint-disable-next-line @typescript-eslint/no-require-imports
export const faviconDotPath: string = require('@ms/yammer-assets/dist/web/ve/faviconDot.ico');
